<template>
 <div class="l-container confirm-info ">
    <div class="top-title ">
      <h3 class="font-bold">マイクーポン</h3>
    </div>
    <a-divider/>
    <div class="main-content flex">
      <div class="left-content my-4 ">
        <LeftMenuBar :nav-bars="navBars"/>
      </div>
      <div class="right-content">
        <div class="back-to" @click="$router.go(-1)">
          <i class="icon icon-bor-arrow-left text-red-500 flex items-center"></i>
          <p>マイクーポンに戻る</p>
        </div>

        <div class="box-right">
          <CouponDetail :item="couponDetail" />
          <div class="title-expire">
            
            <div class="title-expire_inner">
              <h3 v-if="couponDetail.expireTo || couponDetail.ticketDate" class="c-title">
                  {{ couponDetail.expireTo ?  '有効期限' : 'ご利用日'}} 
                <strong>
                  {{ dateValue }}
                </strong>
              </h3>
              <ul>
                <li>
                  <div class="checkbox">
                    <a-checkbox > てもみんグループ利用チケット利用コード1,080円分 </a-checkbox>
                  </div>
                </li>
              </ul>
              <div class="button-save">
                <a-button class="black-button">
                  選択したクーポンを利用する
                </a-button>
              </div>
            </div>
          </div>  
          <div >
            <div v-if="couponDescription.couponDtl" class="c-card__inner4">
              <SectionContentTitle lineType="v-line" titleContent="クーポン詳細"/>
              <p>
                {{ couponDescription.couponDtl }}
              </p>
            </div>

            <div v-if="couponDescription.couponUseFlow" class="c-card__inner4">
              <SectionContentTitle lineType="v-line" titleContent="ご利用の流れ"/>
              <p>
                {{ couponDescription.couponUseFlow }}
              </p>
            </div>

            <div v-if="couponDescription.usageNotes" class="c-card__inner4">
              <SectionContentTitle lineType="v-line" titleContent="注意事項"/>
              <p>
                {{ couponDescription.usageNotes }}
              </p>
            </div>

            <div class="c-card__inner4">
              <SectionContentTitle lineType="v-line" titleContent="お申込み情報"/>
              <p>
                BSID（Bアカウント）： 449920000000002<br />
                <span wovn-ignore>会員氏名： </span> 氏名未設定 <br />
                受付番号： 211126000098
              </p>
            </div>  

            <div v-if="Object.keys(couponCustumItem).length != 0" class="c-card__inner4">
              <SectionContentTitle lineType="v-line" :titleContent="couponCustumItem.custumItemTitle"/>
              <p>{{ couponCustumItem.custumItemCont }}</p>
            </div>

          </div>
        </div>
        <div class="c-button">
          <a-button >
            <a @click="$router.go(-1)">マイクーポンに戻る</a>
          </a-button>
        </div>
      </div>
    </div>
  </div>
   
</template>

<script>
import CouponDetail from './coupon'
import { LeftMenuBar, SectionContentTitle } from '@/components/compound'
import { GET_COUPON_ITEM_DETAIL } from '@/store/modules/menu/actions.js'
import moment from 'moment'

export default {
  components: {
    CouponDetail,
    LeftMenuBar,
    SectionContentTitle
  },
  mounted() {
    this.getCouponDetail()
  },
  methods: {
    getCouponDetail() {
      this.$store.dispatch(GET_COUPON_ITEM_DETAIL).then((data) => { 
        this.couponDetail = data.couponDetail
      })
    }
  },
  computed: {
    dateValue() {
      return this.couponDetail.expireTo ? moment(this.couponDetail.expireTo).format('YYYY年MM月DD日') : moment(this.couponDetail.ticketDate).format('YYYY年MM月DD日') 
    },
  
    couponDescription() {
      if (!this.couponDetail || !this.couponDetail.description) return {}
      return JSON.parse(this.couponDetail.description)
     
    },
    couponCustumItem() {
      if (!this.couponDescription || !this.couponDescription.custumItem) return {}
      return this.couponDescription.custumItem
    }
  },
  data() {
    return {
      navBars: [
        { path: '/mypage', name: 'マイページトップ' },
        { type: 'divider' },
        { path: '/mypage/benepo-history', name: '総保有ベネポ・ベネポ履歴' },
        { path: '/mypage/benepo-collect', name: '獲得予定のベネポ' },
        { type: 'divider' },
        { path: '/mypage/coupons', name: '専用ポイント・補助クーポン' },
        { type: 'divider' },
        { path: 'bs-myp-02-001', name: 'マイクーポン' },
        { path: 'bs-myp-02-010', name: '過去のクーポン' },
        { type: 'divider' },
        { path: '/mypage/orders', name: 'お申し込み履歴' },
        { path: '', name: '給トク払いご利用履歴', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '/mypage/visits', name: '閲覧履歴' },
        { type: 'divider' },
        { path: '/mypage/favorites', name: 'お気に入りメニュー' },
        { type: 'divider' },
        { path: '/mypage/setting', name: '会員プロフィール', icon: 'icon-bor-copy' },
        { path: '', name: 'メール受信・通知', icon: 'icon-bor-copy' },
        { path: '', name: 'クレジットカード', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: '家族アカウント管理', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: 'ログアウト', icon: 'icon icon-bor-logout' }
      ],
      couponDetail: {}
    }
  }

}
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
  /deep/ {
    .ant-btn{
    margin-top: 2rem;
    height: 3.4rem;
    width: 240px;
    border-radius: 8px;
    box-shadow: 0px 1px 8px rgba(31, 32, 33, 0.08);
      a{
        padding: 18px 24px;
        font-weight: bold;
      }
    }
    .button-save{
      @apply flex justify-center;
      .black-button{
        @apply mt-0;
        background-color: black;
        color: white;
        font-weight: bold;
      }
    }
  }
</style>